export const getColumnHeaderTooltipTestId = (tableTestId: string | undefined, columnId: string) => {
	if (!tableTestId) {
		return undefined
	}
	const columnSegment = columnId
		.replace(/([a-z0-9])([A-Z])/g, '$1-$2')
		.replace(/[^a-zA-Z0-9]+/g, '-')
		.replace(/^-|-$/g, '')
		.toLowerCase()
	return `${tableTestId}-header-tooltip-${columnSegment}`
}
